module.exports = __webpack_public_path__ + "img/2_newYouth_dyy.2c86b4dd.png";